export class ActiveIngredientFilterSettingsModel {
  public activeIngredienName: string;
  public alphaIndex: string;
}